export * from "./product-facet";
